/*
 * Noibu A/B test 252: cuff ad 2 (ad id 120248127987170485) landing page on
 * /collections/bracelets. Flag key 4560-gorjana-cuff-ad-2-landing-page.
 * Twin of noibu-flag-cuff.js (test 251) with its own cache key and attribute,
 * so neither test can clear or overwrite the other's saved arm.
 * Variations: "original" (control, today's page), "cuff-landing-page" (B).
 *
 * The gate section's inline script has already painted the cached or forced
 * arm. This script reads the real assignment, updates the html class and the
 * 7-day cache, and reports the rendered arm to Noibu as a custom attribute.
 *
 * - Real assignment (variant present, no errorCode, reason TARGETING_MATCH,
 *   SPLIT or CACHED): show that arm and cache it.
 * - Variant starting with "__" (e.g. "__excluded" for visitors outside the
 *   targeting): a sentinel, not an arm. Nothing cached, nothing reported, the
 *   page left as painted.
 * - Stopped flag, DEFAULT, ERROR, noibuFeatureFlagError, or no SDK 10 s after
 *   window load: forget the cache so the next load is today's page, but never
 *   swap the page the visitor is reading.
 */
(function () {
  'use strict';
  var FLAG = '4560-gorjana-cuff-ad-2-landing-page';
  var STORE = 'nff_cuff2';
  var B = 'nff-cuff-b';
  var A = 'nff-cuff-a';
  var WAIT = 'nff-cuff-wait';
  var REAL = ['TARGETING_MATCH', 'SPLIT', 'CACHED'];
  var html = document.documentElement;
  var settled = false;

  function save(v) { try { localStorage.setItem(STORE, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {} }
  function forget() { try { localStorage.removeItem(STORE); } catch (e) {} }
  function show() { html.classList.remove(WAIT); }
  function apply(arm) {
    html.classList.toggle(B, arm === 'b');
    html.classList.toggle(A, arm === 'a');
  }
  function report(how) {
    var arm = html.classList.contains(B) ? 'cuff-landing-page' : 'original';
    var tries = 0;
    (function attempt() {
      var n = window.NOIBUJS;
      if (n && typeof n.addCustomAttribute === 'function') {
        try { n.addCustomAttribute('nff_cuff2_arm', arm + (how ? ' (' + how + ')' : '')); } catch (e) {}
        return;
      }
      if (++tries < 40) setTimeout(attempt, 500);
      else if (window.console) console.warn('[nff-cuff2] NOIBUJS not found; arm not reported');
    })();
  }

  // Returns 'a' | 'b' for a real assignment, '__' for a sentinel, null otherwise.
  function armOf(d) {
    if (!d || d.errorCode) return null;
    var v = d.variant || d.variation || d.value;
    if (!v) return null;
    v = String(v);
    if (v.indexOf('__') === 0) return '__';
    if (REAL.indexOf(d.reason) < 0) return null;
    var k = v.toLowerCase().replace(/\s+/g, '-');
    if (k === 'cuff-landing-page') return 'b';
    if (k === 'original') return 'a';
    return null;
  }

  function fail(why) {
    if (settled) return;
    settled = true;
    forget();
    show();
    if (window.console) console.info('[nff-cuff2] no assignment (' + why + '); page left as painted');
  }

  // final: the SDK says it is ready, so a non-answer now is a real non-answer.
  function evaluate(final) {
    if (settled) return true;
    var F = window.NoibuFeatureFlag;
    if (!F || typeof F.getClient !== 'function') { if (final) fail('no sdk'); return false; }
    var d;
    try { d = F.getClient().getStringDetails(FLAG, 'original'); } catch (e) { if (final) fail('evaluate threw'); return false; }
    var arm = armOf(d);
    if (arm === 'a' || arm === 'b') {
      settled = true;
      save(arm);
      apply(arm);
      show();
      report('');
      return true;
    }
    if (arm === '__') {
      settled = true;
      show();
      return true;
    }
    if (final) fail((d && (d.errorCode || d.reason)) || 'no result');
    return false;
  }

  // QA override (handled by test 251's script): stay out of the way.
  if (html.hasAttribute('data-nff-cuff-forced')) return;

  if (evaluate(false)) return;

  window.addEventListener('noibuFeatureFlagReady', function () { evaluate(true); });
  window.addEventListener('noibuFeatureFlagError', function () { fail('sdk error'); });

  // The ready event may have fired before this script ran: poll briefly too.
  var polls = 0;
  var poller = setInterval(function () {
    if (evaluate(false) || settled || ++polls > 40) clearInterval(poller);
  }, 250);

  function giveUp() { setTimeout(function () { if (!settled) evaluate(true); }, 10000); }
  if (document.readyState === 'complete') giveUp();
  else window.addEventListener('load', giveUp);
})();
